<mat-dialog-content>
  <div class="delete-option-choice-container">
    <h1>Delete dashboard</h1>
    <div class="options-container">
      <button (click)="onDeleteCurrentDraft()">Delete current draft</button>
      <button (click)="onDeleteAllDrafts()">Delete all drafts</button>
    </div>
  </div>
</mat-dialog-content>
